export const adminApiConfig = {
	apiVersion: "v1",
};